import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { playCourseUrl } from "../../../Infrastructure/Config/ApiConfig";
import { getLearnerCourseAsync } from "../../../Services/CourseService";
import Card from "../../../Shared/Components/Card/Card";
import Header from "../../../Shared/Components/Header/Header";
import LineIcon from "react-lineicons";
import moment from "moment";
import { getStatusBadge } from "./../../../Infrastructure/Utilities/LearnerProgressHelper";
import Button from "./../../../Shared/Components/Button/Button";
import Modal from "./../../../Shared/Components/Modal/Modal";
import { restartCourseAsync } from "./../../../Services/CourseService";
import { showToast } from "../../../Infrastructure/Notifications/ToastrConfig";
import "./Engage.scss";
import { Line } from "rc-progress";
import { useAuthState } from "../../../Services/AuthService";

const Engage = () => {
    const [state, setState] = useState({ course: { feedbackForm: null } });
    const { id } = useParams();
    const [forceChange, setForceChange] = useState(false);
    const auth = useAuthState();
    // const [hubConnection, setHubConnection] = useState(null);

    useEffect(() => {
        const getCourse = async () => {
            let response = await getLearnerCourseAsync(id);
            setState(response);
        };
        getCourse();
    }, [auth.user, id, forceChange]);

    // useEffect(() => {
    //     setHubConnection(getConnection());
    // }, [])

    // useEffect(() => {
    //     if (hubConnection) {
    //         connect(hubConnection);
    //         handleProgress(hubConnection);
    //     }
    // }, [hubConnection])

    // const getConnection = () => {
    //     return new HubConnectionBuilder()
    //         .withUrl(courseProgressHubUrl())
    //         .build();
    // }

    // const connect = connection => {
    //     connection.start()
    //         .then(() => { console.log("Connected to hub") })
    //         .catch();
    // }

    // const handleProgress = connection => {
    //     connection.on(getUserId(), (result) => {
    //         setState(
    //             s => ({
    //                 progress: result.progress,
    //                 scorePercentage: result.scorePercentage,
    //                 startedDateTime: result.startedDateTime,
    //                 lessonStatus: result.lessonStatus,
    //                 completedDateTime: result.completedDateTime,
    //                 trackingId: s.trackingId,
    //                 course: s.course,
    //             })
    //         )
    //         console.log(result);
    //     })
    // }

    const launchCourse = async () => {
        let storedUser = auth.user;
        if (!storedUser?.id) {
            return;
        }
        window.open(
            `${playCourseUrl()}${storedUser.id}/${id}`,
            state.course.title,
            "toolbar=no,menubar=no,location=no"
        );
    };

    const previewCourse = async () => {
        window.open(
            `${playCourseUrl()}preview/${id}`,
            state.course.title,
            "toolbar=no,menubar=no,location=no"
        );
    };

    const restartCourse = async () => {
        console.log(`trackingId: ${state.trackingId}`);
        let data = {
            trackingId: state.trackingId,
        };

        let response = await restartCourseAsync(data);
        if (response) {
            showToast(true, "Course progress reset");
            setForceChange(!forceChange);
        } else {
            showToast(false, "Something went wrong");
        }
    };

    const progressPercent = state.progress !== null && state.progress !== undefined
        ? state.progress
        : state.completedDateTime !== null
            ? 100
            : 0;

    // Certificates and badges are only issued once every module is complete - passing the
    // assessment (lessonStatus 4) alone isn't enough. trackingId is the learner-course id.
    const isCourseComplete = Boolean(state.completedDateTime);
    const certificateUrl = `/certificate/${state.trackingId}`;
    const verifyUrl = `${window.location.origin}/verify/${state.trackingId}`;

    return (
        <div className="engage-page">
            <Modal
                modalId="restart"
                buttonText="Restart"
                bodyText="Are you sure you want to restart this course? All progress will be lost."
                title="Restart course"
                buttonFunc={restartCourse}
            />
            <Header
                heading={state.course.title}
                subheading={getStatusBadge(state.lessonStatus, state.scorePercentage)}
                icon="book"
            />
            <div className="container-fluid content engage-content">
                <div className="row">
                    <div className="col-12 col-lg-8">
                        <Card classes="course-main-card">
                            <div className="course-description">
                                <p>{state.course.description}</p>
                            </div>

                            <div className="course-note">
                                <LineIcon name="info" />
                                <span>It's a good idea to close all open browser tabs and applications before beginning this module.</span>
                            </div>

                            {isCourseComplete && (
                                <div className="course-completion-message">
                                    <div className="completion-icon">
                                        <LineIcon name="check-circle" />
                                    </div>
                                    <div className="completion-text">
                                        <h5>Congratulations!</h5>
                                        <p>You've completed <strong>{state.course.title}</strong>. Download your certificate and view your digital badge below.</p>
                                    </div>
                                </div>
                            )}
                        </Card>

                        <div className="stats-grid">
                            <div className="stat-item">
                                <div className="stat-icon" style={{ backgroundColor: '#0ea5e9' }}>
                                    <LineIcon name="calendar" />
                                </div>
                                <div className="stat-content">
                                    <span className="stat-label">Started</span>
                                    <span className="stat-value">
                                        {state.startedDateTime !== null
                                            ? moment(state.startedDateTime).format("MMM D, YYYY")
                                            : "Not Started"}
                                    </span>
                                </div>
                            </div>

                            {state?.course?.hasAssessment && (
                                <div className="stat-item">
                                    <div className="stat-icon" style={{ backgroundColor: '#f59e0b' }}>
                                        <LineIcon name="star" />
                                    </div>
                                    <div className="stat-content">
                                        <span className="stat-label">Score</span>
                                        <span className="stat-value">
                                            {state.scorePercentage !== null && state.scorePercentage !== undefined
                                                ? `${Math.round(state.scorePercentage)}%`
                                                : '-'}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="col-12 col-lg-4">
                        <Card classes="actions-card">
                            <h5 className="actions-title">Course Actions</h5>

                            <div className="actions-list">
                                {state.completedDateTime === null ? (
                                    <button
                                        className="action-btn action-btn-success"
                                        onClick={launchCourse}
                                    >
                                        <LineIcon name="play" />
                                        <span>{state.startedDateTime === null ? "Start Course" : "Continue Course"}</span>
                                    </button>
                                ) : (
                                    <button
                                        className="action-btn action-btn-primary"
                                        onClick={previewCourse}
                                    >
                                        <LineIcon name="reload" />
                                        <span>Review Course</span>
                                    </button>
                                )}

                                {isCourseComplete && (
                                    <>
                                        {state.course.feedbackRequired &&
                                            !state.feedbackComplete &&
                                            state.course.feedbackForm !== null ? (
                                            <Button
                                                link={`/feedback/${state.course.feedbackForm.id}`}
                                                classes="action-btn action-btn-secondary"
                                                text="Complete Feedback"
                                            />
                                        ) : (
                                            <a
                                                href={certificateUrl}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="action-btn action-btn-success"
                                            >
                                                <LineIcon name="download" />
                                                <span>Download Certificate</span>
                                            </a>
                                        )}
                                        <a
                                            href={verifyUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="action-btn action-btn-primary"
                                        >
                                            <LineIcon name="star" />
                                            <span>View Badge</span>
                                        </a>
                                        <a
                                            target="_blank"
                                            rel="noreferrer"
                                            href={`https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${encodeURIComponent(state.course.title || "")
                                                }&organizationId=72763993&issueYear=${moment(
                                                    state.completedDateTime
                                                ).format("Y")}&issueMonth=${moment(
                                                    state.completedDateTime
                                                ).format(
                                                    "MM"
                                                )}&certUrl=${encodeURIComponent(verifyUrl)}&certId=${state.trackingId
                                                }`}
                                            className="action-btn action-btn-linkedin"
                                        >
                                            <LineIcon name="linkedin" />
                                            <span>Add to LinkedIn</span>
                                        </a>
                                    </>
                                )}

                                {state.startedDateTime !== null && state.lessonStatus !== 4 && (
                                    <button
                                        className="action-btn action-btn-danger-outline"
                                        data-target="#restart"
                                        data-toggle="modal"
                                    >
                                        <LineIcon name="reload" />
                                        <span>Restart Course</span>
                                    </button>
                                )}
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Engage;
